async function determineZoneAndDeliveryOption(currentCartWeight = 0) {
  const cocElement = qs('.js-delivery');
  const zonesData = await fetchZonesData();
  if (!zonesData) {
    return;
  }

  const userSelectedCountryName = cocElement?.dataset.deliveryCountry;
  currentCartWeight && (cocElement.dataset.totalWeight = currentCartWeight);
  const userSelectedWeight = currentCartWeight === 0 ? parseFloat(cocElement?.dataset.totalWeight) : currentCartWeight;
  const cocDelivery = qs('.storepickup-tab');

  zonesData && zonesData.map((data) => {
    const provinces = data.provinces[0].code;
    const activeZone = provinces.find((province) => province === userSelectedCountryName);
    
    if (activeZone !== undefined) {
      const collectionPoint = data.provinces[0].collection_point ? data.provinces[0].collection_point.option : [];
      const country_value = collectionPoint.find((item) => item.country_value === userSelectedCountryName);
      const homeDeliveryWeight = data.provinces[0].home_delivery_weight ? data.provinces[0].home_delivery_weight.option : [];
      const collectionPointWeight = data.provinces[0].collection_point_weight ? data.provinces[0].collection_point_weight.option : [];
      const mondialrelayWrapper = qs('.js-delivery-option_select');
      const colissimoWrapper = qs('.js-delivery-option_select-2');
      const homeDeliveryPrice = qs('.js-home-delivery');
      const cocDeliveryPrice = qs('.js-coc-delivery');
      const isCoc = document.getElementById('storePickupRadio');
      const cocPickupInput = document.getElementById('colissimoPickUp');
      
      if(userSelectedWeight > 10) {
        cocDelivery.style.display = 'none';
        localStorage.removeItem('user-country');
      } else {
        if (!collectionPoint || collectionPoint.length === 0) {
          cocDelivery.style.display = 'none';
          localStorage.removeItem('user-country');
        } else {
          cocDelivery.style.display = 'block';
        }
      }
      
      if (collectionPoint) {
        if ( country_value ) {
          if (country_value.option_delivery[0].value === 'YES') {
            colissimoWrapper.style.display = 'none'
            localStorage.removeItem('user-country');
          } else {
            mondialrelayWrapper.style.display = 'none'
            localStorage.setItem('user-country', userSelectedCountryName);
            setInterval(function () {
              isCoc.addEventListener('change', function() {
                if (this.checked) {
                  localStorage.setItem('user-country', userCocCountryName);
                  cocPickupInput.value = true;
                } else {
                  cocPickupInput.value = false;
                }
              });
            }, 100);

          }
        }
      }

      homeDeliveryWeight && homeDeliveryWeight.forEach((index) => {
        const minWeight = index['min_weight'].replace('kg', '');
        const maxWeight = index['max_weight'].replace('kg', '');

        if (userSelectedWeight >= parseFloat(minWeight) && userSelectedWeight <= parseFloat(maxWeight)) {
          let price = index['weight_price']
          homeDeliveryPrice.textContent = `€${price}`;
        }
      })

      collectionPointWeight && collectionPointWeight.forEach((index) => {
        const minWeight2 = index['min_weight'].replace('kg', '');
        const maxWeight2 = index['max_weight'].replace('kg', '');

        if (userSelectedWeight >= parseFloat(minWeight2) && userSelectedWeight <= parseFloat(maxWeight2)) {
          let price = index['weight_price'];
          cocDeliveryPrice.textContent = `€${price}`;
        }
      })
    }
  })
}  

async function fetchZonesData() {
  const cocElement = qs('.js-delivery');
  try {
    const response = await fetch(cocElement.dataset.deliveryOptions); // delivery json file

    if (!response.ok) {
      throw new Error('Failed to fetch zones data.');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return null;
  }
}

(() => {
  function cartAddQuantity() {
    const addItemCart = qsa('.js-cart-button-plus');
    if (addItemCart) {
      addItemCart.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          const wrapper = getClosest('.js-cart-quantity-wrapper', e.target);
          const itemInput = qs('.js-cart-quantity-input', wrapper);
          const maxQuantity = itemInput.getAttribute("max");
          
          if (itemInput) {
            if (itemInput.classList.contains('js-cart-quantity-input')) {
              let itemLine = itemInput.dataset.itemLine;
              let itemID = itemInput.dataset.itemId;
              let inputValue = parseInt(itemInput.value, 10);
              inputValue = isNaN(inputValue) ? 0 : inputValue;
              
              if (inputValue < parseInt(maxQuantity, 10)) {
                inputValue = inputValue + 1;
                itemInput.value = inputValue;
                handleUpdateItem(itemLine, inputValue, itemID);
              } else {
                itemInput.value = inputValue;
                handleUpdateItem(itemLine, inputValue, itemID);
              } 
            }
          }
        });
      });
    }
  }

  function cartMinusQuantity() {
    const minusItemCart = qsa('.js-cart-button-minus');
    if (minusItemCart) {
      minusItemCart.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault;
          const wrapper = getClosest('.js-cart-quantity-wrapper', e.target);
          const itemInput = qs('.js-cart-quantity-input', wrapper);
          if (itemInput) {
            if (itemInput.classList.contains('js-cart-quantity-input')) {
              let itemLine = itemInput.dataset.itemLine;
              let itemID = itemInput.dataset.itemId;
              let inputValue = parseInt(itemInput.value, 10);
              if (inputValue < 2) {
                itemInput.value = inputValue;
                handleUpdateItem(itemLine, 0, itemID);
              } else {
                inputValue = isNaN(inputValue) ? 0 : inputValue;
                inputValue--;
                itemInput.value = inputValue;
                handleUpdateItem(itemLine, inputValue, itemID);
              }
            }
          }
        });
      });
    }
  }

  function cartHandleInput() {
    const itemQuantityInput = qsa('.js-cart-quantity-input');

    if (itemQuantityInput) {
      itemQuantityInput.forEach((input) => {
        function inputFunc(el) {
          let itemLine = el.target.dataset.itemLine;
          let itemID = el.target.dataset.itemId;
          let inputValue = parseInt(el.target.value, 10);
          if (inputValue > 0 && inputValue !== 0) {
            inputValue = isNaN(inputValue) ? 0 : inputValue;
            handleUpdateItem(itemLine, inputValue, itemID);
          } else {
            if (inputValue === 0) {
              el.target.value = 1;
              handleUpdateItem(itemLine, 1, itemID);
            }
          }
        }
        input.addEventListener('change', (e) => {
          inputFunc(e);
        });
        input.addEventListener('keyup', (e) => {
          inputFunc(e);
        });
        input.addEventListener('paste', (e) => {
          inputFunc(e);
        });
      });
    }
  }

  function handleUpdateItem(line, qty, id) {
    let formData = {
      line: line,
      quantity: qty,
    };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data) {
          if (data.items) {
            let discountedPrice = 0;
            let discountedFinalPrice = 0;

            const cartTotalWeight = data.total_weight / 1000;

            determineZoneAndDeliveryOption(cartTotalWeight);

            data.items.forEach((el) => {
              
              let originalPrice = qs(`.js-cart__items-original-price-${el.id}`);  
              let comparePrice = qs(`.js-cart__items-compare-price-${el.id}`);
                const itemTotalPrice = qs(`.js-cart-total-price-${el.id}`);

                if (itemTotalPrice) {
                  let finalVal = cartFormatMoney(el.original_line_price);
                  itemTotalPrice.innerHTML = `${finalVal}`;
                }
                
                if (originalPrice && originalPrice.dataset && originalPrice.dataset.originalPrice &&
                    comparePrice && comparePrice.dataset && comparePrice.dataset.comparePrice) {
                  discountedPrice = (comparePrice.dataset.comparePrice - originalPrice.dataset.originalPrice) * el.quantity;
                  discountedFinalPrice += discountedPrice;
                }
              
            });
            let subTotalVal = cartFormatMoney(data.items_subtotal_price);
            let cartCounterValue = qs('#js-header-cart-count');
            const subTotalPrice = qs('.cart__checkout-subtotal-amount');
            const discountPrice = qs('.js-discount-rate');
            cartCounterValue.innerHTML = data.item_count;
            if (subTotalPrice) {
              subTotalPrice.setAttribute(
                'data-header-cart--total',
                subTotalVal.substr(1, subTotalVal.length)
              );
              subTotalPrice.innerHTML = subTotalVal;
               if (discountPrice) {
                discountPrice.innerHTML = cartFormatMoney(discountedFinalPrice);
               }              
            }

            if (qsa('.js-free_shipping_progress__bar')) {
              qsa('.js-free_shipping_progress__bar').forEach((el) => {
                el.dataset.totalPrice = data.items_subtotal_price / 100;
              });
              recalculateShippingThreshold();
            }
          }
        }
        if (formData.quantity == 0) {
          location.reload();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function cartFormatMoney(val) {
    const cartItems = document.querySelector('.js-cart-items');
    if (cartItems) {
      return window.Shopify.theme.currency.formatMoney(val);
    }
  }

  function recalculateShippingThreshold() {
    const containers = qsa('.js-free_shipping_progress');

    if (containers) {
      const progressBarFull = 'free_shipping_progress__bar--full';

      containers.forEach((el) => {    
        el.style.display = 'block';

        const status = qs('.js-free_shipping_progress__status', el);
        const statusMoney = qs('.js-free_shipping_progress__status_money', el);
        const qualified = qs('.js-free_shipping_progress__qualified', el);
        const bar = qs('.js-free_shipping_progress__bar', el);
        const progressBar = qs('.js-free_shipping_progress__progress_bar', el);
        const dataset = bar.dataset;
  
        let progress = (dataset.totalPrice / dataset.threshold) * 100;
  
        if (progress > 100) {
          progress = 100;
        }
  
        var difference = Math.abs(dataset.totalPrice - dataset.threshold) * 100;
        statusMoney.innerHTML = cartFormatMoney(difference);
        qualified.style.display = 'none';
        status.style.display = 'block';
        bar.classList.remove(progressBarFull);
        progressBar.style.setProperty('--progress', `${progress}%`);
  
        if (progress === 100) {
          bar.classList.add(progressBarFull);
          qualified.style.display = 'block';
          status.style.display = 'none';
        }
      });      
    }
  }
  
  determineZoneAndDeliveryOption();
  window.addEventListener('DOMContentLoaded', () => {
    cartAddQuantity();
    cartMinusQuantity();
    cartHandleInput();

    const containersFreeShippingProgress = qsa('.js-free_shipping_progress');
    let containersFreeShippingProgressInitialize = false;

    if (containersFreeShippingProgress) {
      containersFreeShippingProgress.forEach((el) => {
        containersFreeShippingProgressInitialize = (el.dataset && el.dataset.initialize != 'false');
      });

      if (containersFreeShippingProgressInitialize) {
        recalculateShippingThreshold();
      }
    }
  })
})();
